export default "__VITE_ASSET__d6e475fa__"